import { render, staticRenderFns } from "./ModalMensalista.vue?vue&type=template&id=d8827c74&scoped=true&"
import script from "./ModalMensalista.vue?vue&type=script&lang=js&"
export * from "./ModalMensalista.vue?vue&type=script&lang=js&"
import style0 from "./ModalMensalista.vue?vue&type=style&index=0&id=d8827c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8827c74",
  null
  
)

export default component.exports